<script>
import IconBase from '@/packages/ui/components/Icon/Icon.vue';
import Tooltip from '@/packages/ui/components/Tooltip/Tooltip.vue';

export default {
  name: 'TableActionButton',
  components: {
    IconBase,
    Tooltip,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    iconName: {
      type: String,
      default: '',
    },
    tooltipPosition: {
      type: String,
      default: 'middle left',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '20',
    },
  },
};
</script>

<template>
  <Tooltip
    :text="tooltipText"
    :position="tooltipPosition"
  >
    <button
      class="t-TableActionButton"
      type="button"
      :disabled="disabled"
      @click="$emit('click')"
    >
      <slot>
        <IconBase
          v-if="iconName"
          :name="iconName"
          :stop-propagation="false"
          color="var(--track-color-bluegray-80)"
          :size="iconSize"
        />
      </slot>
    </button>
  </Tooltip>
</template>

<style lang="scss" scoped>
.t-TableActionButton {
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  height: var(--track-icon-size-sm);
  justify-content: center;
  margin: 0;
  outline: none;
  padding: 0;
  width: var(--track-icon-size-sm);
}
</style>
